export const SENDER_ADDRESS_LAST_USED_ADDRESS = 'SENDER_ADDRESS_LAST_USED_ADDRESS'
export const SENDER_ADDRESS_SET_ADDRESSES = 'SENDER_ADDRESS_SET_ADDRESSES'
export const SENDER_ADDRESS_SET_ADDRESS = 'SENDER_ADDRESS_SET_ADDRESS'
